import React, { useState, useEffect } from 'react';
import api from '../api';

function eur(v) { return v ? parseFloat(v).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }) : '–'; }

export default function ReportPage() {
  const [tab, setTab] = useState('vorrat');
  const [einkauf, setEinkauf] = useState(null);
  const [vorrat, setVorrat] = useState(null);
  const [laden, setLaden] = useState(true);

  useEffect(() => { laden_daten(); }, []);

  async function laden_daten() {
    setLaden(true);
    try {
      const [e, v] = await Promise.all([
        api.get('/auswertung/einkauf'),
        api.get('/auswertung/vorrat')
      ]);
      setEinkauf(e.data);
      setVorrat(v.data);
    } catch(e) { console.error(e); }
    setLaden(false);
  }

  async function pdfErstellen() {
    const { jsPDF } = await import('jspdf');
    const { default: autoTable } = await import('jspdf-autotable');
    const doc = new jsPDF();
    const heute = new Date().toLocaleDateString('de-DE');

    if (tab === 'vorrat' && vorrat) {
      doc.setFontSize(20);
      doc.text('Vorratskammer Report', 14, 20);
      doc.setFontSize(10);
      doc.text(`Erstellt: ${heute}`, 14, 28);

      // Zusammenfassung
      doc.setFontSize(14);
      doc.text('Zusammenfassung', 14, 40);
      autoTable(doc, {
        startY: 45,
        head: [['Gesamt Artikel', 'Gesamtwert', 'Unter Mindestbestand', 'Bald ablaufend']],
        body: [[
          vorrat.gesamt?.anzahl || 0,
          eur(vorrat.gesamt?.gesamtwert),
          vorrat.niedrig?.length || 0,
          vorrat.ablaufend?.length || 0
        ]],
        headStyles: { fillColor: [99, 102, 241] }
      });

      // Artikel unter Mindestbestand
      if (vorrat.niedrig?.length > 0) {
        doc.setFontSize(14);
        doc.text('Artikel unter Mindestbestand', 14, doc.lastAutoTable.finalY + 15);
        autoTable(doc, {
          startY: doc.lastAutoTable.finalY + 20,
          head: [['Artikel', 'Kategorie', 'Bestand', 'Mindest', 'Einheit']],
          body: vorrat.niedrig.map(v => [v.name, v.kat_name||'–', v.menge, v.mindestbestand, v.einheit]),
          headStyles: { fillColor: [239, 68, 68] }
        });
      }

      // Bald ablaufend
      if (vorrat.ablaufend?.length > 0) {
        doc.setFontSize(14);
        doc.text('Bald ablaufende Artikel', 14, doc.lastAutoTable.finalY + 15);
        autoTable(doc, {
          startY: doc.lastAutoTable.finalY + 20,
          head: [['Artikel', 'Kategorie', 'Menge', 'Haltbarkeit', 'Lagerort']],
          body: vorrat.ablaufend.map(v => [v.name, v.kat_name||'–', `${v.menge} ${v.einheit}`, v.haltbarkeit, v.lagerort||'–']),
          headStyles: { fillColor: [245, 158, 11] }
        });
      }

      // Gesamtbestand
      doc.addPage();
      doc.setFontSize(14);
      doc.text('Gesamter Vorrat', 14, 20);
      autoTable(doc, {
        startY: 25,
        head: [['Artikel', 'Kategorie', 'Menge', 'Einheit', 'Mindest', 'Haltbarkeit', 'Wert']],
        body: vorrat.alle?.map(v => [
          v.name, v.kat_name||'–', v.menge, v.einheit,
          v.mindestbestand, v.haltbarkeit||'–', eur(v.preis ? v.preis * v.menge : null)
        ]) || [],
        headStyles: { fillColor: [99, 102, 241] },
        styles: { fontSize: 8 }
      });

      doc.save(`Vorrat_Report_${heute.replace(/\./g,'-')}.pdf`);

    } else if (tab === 'einkauf' && einkauf) {
      doc.setFontSize(20);
      doc.text('Einkauf Auswertung', 14, 20);
      doc.setFontSize(10);
      doc.text(`Erstellt: ${heute}`, 14, 28);

      // Häufigste Artikel
      doc.setFontSize(14);
      doc.text('Häufigst gekaufte Artikel', 14, 40);
      autoTable(doc, {
        startY: 45,
        head: [['Artikel', 'Anzahl', 'Ø Preis', 'Gesamt']],
        body: einkauf.haeufig?.map(a => [a.name, a.anzahl, eur(a.durchschnittspreis), eur(a.gesamtpreis)]) || [],
        headStyles: { fillColor: [99, 102, 241] }
      });

      // Ausgaben pro Kategorie
      doc.setFontSize(14);
      doc.text('Ausgaben pro Kategorie', 14, doc.lastAutoTable.finalY + 15);
      autoTable(doc, {
        startY: doc.lastAutoTable.finalY + 20,
        head: [['Kategorie', 'Artikel', 'Gesamtausgaben']],
        body: einkauf.kategorien?.map(k => [k.icon + ' ' + (k.name||'Sonstiges'), k.anzahl, eur(k.gesamtpreis)]) || [],
        headStyles: { fillColor: [16, 185, 129] }
      });

      doc.save(`Einkauf_Auswertung_${heute.replace(/\./g,'-')}.pdf`);
    }
  }

  function drucken() {
    window.print();
  }

  if (laden) return <div style={{ textAlign: 'center', padding: '60px', color: '#94a3b8' }}>⏳ Lade Daten...</div>;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h1 style={{ margin: 0, fontSize: '22px', fontWeight: '700' }}>📊 Reports</h1>
        <div style={{ display: 'flex', gap: '8px' }}>
          <button onClick={drucken} style={{ padding: '10px 14px', background: '#f1f5f9', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: '600', fontSize: '13px' }}>🖨️ Drucken</button>
          <button onClick={pdfErstellen} style={{ padding: '10px 14px', background: '#6366f1', color: 'white', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: '600', fontSize: '13px' }}>📄 PDF</button>
        </div>
      </div>

      {/* Tab Auswahl */}
      <div style={{ display: 'flex', background: '#f1f5f9', borderRadius: '10px', padding: '4px', marginBottom: '16px' }}>
        {[['vorrat','📦 Vorrat'],['einkauf','🛒 Einkauf']].map(([v,l]) => (
          <button key={v} onClick={() => setTab(v)}
            style={{ flex: 1, padding: '10px', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: tab===v?'700':'400',
              background: tab===v?'white':'transparent', color: tab===v?'#6366f1':'#64748b',
              boxShadow: tab===v?'0 1px 3px rgba(0,0,0,0.1)':'none' }}>
            {l}
          </button>
        ))}
      </div>

      {/* Vorrat Report */}
      {tab === 'vorrat' && vorrat && (
        <div>
          {/* KPI */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: '10px', marginBottom: '16px' }}>
            {[
              { label: 'Artikel gesamt', wert: vorrat.gesamt?.anzahl || 0, icon: '📦', farbe: '#6366f1' },
              { label: 'Gesamtwert', wert: eur(vorrat.gesamt?.gesamtwert), icon: '💰', farbe: '#10b981' },
              { label: 'Unter Mindestbestand', wert: vorrat.niedrig?.length || 0, icon: '⚠️', farbe: '#f59e0b' },
              { label: 'Bald ablaufend', wert: vorrat.ablaufend?.length || 0, icon: '⏰', farbe: '#ef4444' },
            ].map((k,i) => (
              <div key={i} style={{ background: 'white', borderRadius: '12px', padding: '14px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', borderLeft: `3px solid ${k.farbe}` }}>
                <div style={{ fontSize: '20px' }}>{k.icon}</div>
                <div style={{ fontSize: '20px', fontWeight: '700', color: k.farbe }}>{k.wert}</div>
                <div style={{ fontSize: '11px', color: '#64748b' }}>{k.label}</div>
              </div>
            ))}
          </div>

          {/* Nach Kategorie */}
          {vorrat.nachKategorie?.length > 0 && (
            <div style={{ background: 'white', borderRadius: '12px', padding: '16px', marginBottom: '12px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
              <h3 style={{ margin: '0 0 12px', fontSize: '15px' }}>🏷️ Wert nach Kategorie</h3>
              {vorrat.nachKategorie.filter(k => k.anzahl > 0).map((k,i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #f1f5f9' }}>
                  <span style={{ fontSize: '14px' }}>{k.icon} {k.name || 'Sonstiges'} <span style={{ color: '#94a3b8', fontSize: '12px' }}>({k.anzahl})</span></span>
                  <span style={{ fontWeight: '700', color: '#10b981', fontSize: '14px' }}>{eur(k.wert)}</span>
                </div>
              ))}
            </div>
          )}

          {/* Unter Mindestbestand */}
          {vorrat.niedrig?.length > 0 && (
            <div style={{ background: 'white', borderRadius: '12px', padding: '16px', marginBottom: '12px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
              <h3 style={{ margin: '0 0 12px', fontSize: '15px', color: '#f59e0b' }}>⚠️ Unter Mindestbestand ({vorrat.niedrig.length})</h3>
              {vorrat.niedrig.map((v,i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #f1f5f9', fontSize: '14px' }}>
                  <span>{v.kat_icon} {v.name}</span>
                  <span style={{ color: '#ef4444', fontWeight: '700' }}>{v.menge}/{v.mindestbestand} {v.einheit}</span>
                </div>
              ))}
            </div>
          )}

          {/* Bald ablaufend */}
          {vorrat.ablaufend?.length > 0 && (
            <div style={{ background: 'white', borderRadius: '12px', padding: '16px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
              <h3 style={{ margin: '0 0 12px', fontSize: '15px', color: '#ef4444' }}>⏰ Bald ablaufend ({vorrat.ablaufend.length})</h3>
              {vorrat.ablaufend.map((v,i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #f1f5f9', fontSize: '14px' }}>
                  <span>{v.kat_icon} {v.name}</span>
                  <span style={{ color: '#f59e0b', fontWeight: '700' }}>{new Date(v.haltbarkeit).toLocaleDateString('de-DE')}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Einkauf Report */}
      {tab === 'einkauf' && einkauf && (
        <div>
          {/* Häufigste Artikel */}
          {einkauf.haeufig?.length > 0 && (
            <div style={{ background: 'white', borderRadius: '12px', padding: '16px', marginBottom: '12px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
              <h3 style={{ margin: '0 0 12px', fontSize: '15px' }}>🏆 Häufigst gekaufte Artikel</h3>
              {einkauf.haeufig.slice(0,10).map((a,i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #f1f5f9' }}>
                  <div>
                    <span style={{ fontSize: '14px', fontWeight: '600' }}>{a.name}</span>
                    {a.durchschnittspreis > 0 && <span style={{ fontSize: '11px', color: '#94a3b8', marginLeft: '8px' }}>Ø {eur(a.durchschnittspreis)}</span>}
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontWeight: '700', color: '#6366f1' }}>{a.anzahl}x</div>
                    {a.gesamtpreis > 0 && <div style={{ fontSize: '11px', color: '#10b981' }}>{eur(a.gesamtpreis)}</div>}
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Ausgaben pro Kategorie */}
          {einkauf.kategorien?.length > 0 && (
            <div style={{ background: 'white', borderRadius: '12px', padding: '16px', marginBottom: '12px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
              <h3 style={{ margin: '0 0 12px', fontSize: '15px' }}>🏷️ Ausgaben pro Kategorie</h3>
              {einkauf.kategorien.map((k,i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #f1f5f9', fontSize: '14px' }}>
                  <span>{k.icon} {k.name || 'Sonstiges'} <span style={{ color: '#94a3b8', fontSize: '12px' }}>({k.anzahl} Artikel)</span></span>
                  <span style={{ fontWeight: '700', color: '#10b981' }}>{eur(k.gesamtpreis)}</span>
                </div>
              ))}
            </div>
          )}

          {/* Einkaufshistorie */}
          {einkauf.historie?.length > 0 && (
            <div style={{ background: 'white', borderRadius: '12px', padding: '16px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
              <h3 style={{ margin: '0 0 12px', fontSize: '15px' }}>📋 Letzte Einkaufslisten</h3>
              {einkauf.historie.map((h,i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #f1f5f9', fontSize: '14px' }}>
                  <span>{h.liste}</span>
                  <span style={{ color: '#64748b', fontSize: '12px' }}>{h.erledigt}/{h.artikel} Artikel</span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
